import React, { FC } from 'react'
import { Rings } from 'react-loader-spinner'

import colors from '../../theme/colors'

import * as SC from './styled'

export type LoaderProps = {
  className?: string
}

const Loader: FC<LoaderProps> = (props) => {
  const { className } = props

  return (
    <SC.Container className={className}>
      <Rings
        height="80"
        width="80"
        color={colors.nightRider}
        radius="6"
        wrapperStyle={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: `translate(-50%, -50%)`,
        }}
        visible={true}
        ariaLabel="rings-loading"
      />
    </SC.Container>
  )
}

export default Loader
